import { useRef, useState } from 'react';
import './TrarifCards.css';

import { motion } from 'framer-motion';

import advantages from '../../../assets/images/tarif/advantages.png'

const TARIF_MAP = {
    'one_month': {
        price: '18000',
        index: 1,
        title: `Ежемесячная <br />оплата`,
        description: 'Первый платеж — сразу за два месяца, далее ежемесячно.',
    },
    'one_year': {
        price: '200000',
        index: 2,
        title: `Оплата за год <br />со скидкой <span>до 10%</span>`,
        description: 'Получите бесплатный месяц работы интернет-магазина.',
    },
    'two_year': {
        price: '360000',
        index: 3,
        title: `Оплата за два <br />года со скидкой <span>до 20%</span>`,
        description: 'Получите два месяца работы интернет-магазина бесплатно.',
    },
}

const TARIFF_TYPES = [
    {
        type: 'one_month',
        title: '1 месяц',
    },
    {
        type: 'one_year',
        title: '1 год',
    },
    {
        type: 'two_year',
        title: '2 года',
    },
]

const ADVANTAGES = [
    {
        title: 'Уведомления о заказах в Telegram или на почту:',
        texts: [
            'моментально получайте уведомления о заказах прямо в мессенджере, чтобы ничего не пропустить.',
        ]
    },
    {
        title: 'Промокоды:',
        texts: [
            'ведите рекламные кампании с блогерами и создавайте персональные промокоды для друзей или партнеров.',
        ]
    },
    {
        title: 'Умные фильтры:',
        texts: [
            'вам не придется совершать лишние действия, фильтры самостоятельно отобразятся в каталоге у ваших клиентов.',
        ]
    },
    {
        title: 'Умные заказы:',
        texts: [
            'время обработки заказа сократится, а ваши менеджеры смогут узнавать прошлые заказы каждого покупателя, что даст вам возможность совершать дополнительные продажи.',
        ]
    },
    {
        title: 'Уникальный домен на Польза:',
        texts: [
            'получите запоминающийся адрес для вашего магазина.',
        ]
    },
]

const PRODUCT_MANAGE = [
    {
        texts: [
            'Оптимизация выдачи карточек товаров.',
        ]
    },
    {
        texts: [
            'Система управления для заполнения товаров.',
        ]
    },
    {
        texts: [
            'Создание сортировки товаров по категориям и субкатегориям.',
        ]
    },
    {
        texts: [
            'Загрузка товаров файлом таблицы Excel по форматам.',
        ]
    },
    {
        texts: [
            'Выгрузка всей базы данных товаров в формате таблицы для масштабных изменений.',
        ]
    },
]


const SITE_MANAGE = [
    {
        texts: [
            'Загрузка и автоматическое сжатие фотографий.',
        ]
    },
    {
        texts: [
            'Система статусов заказа с автоматической отправкой уведомления покупателю на email.',
        ]
    },
    {
        texts: [
            'Изменение баннеров на главной странице самостоятельно.',
        ]
    },
    {
        texts: [
            'Просмотр прошлых заказов конкретного покупателя.',
        ]
    },
    {
        texts: [
            'Система контент-менеджмента на сайте.',
        ]
    },
    {
        texts: [
            'Исчерпывающая статистика по магазину.',
        ]
    },
    {
        texts: [
            'Разработка уникального дизайна.',
        ]
    },
    {
        texts: [
            'Подключение онлайн-кассы (ЮKassa).',
        ]
    },
    {
        texts: [
            'Менеджмент промокодов.',
        ]
    },
    {
        texts: [
            'Менеджмент заказов.',
        ]
    },
]

function TrarifCards({
    onStartPopupOpen,
}) {

    const [selected, setSelected] = useState('one_month')
    const [isMore, setIsMore] = useState(false)

    const TARIF = TARIF_MAP[selected]

    const dropContentRef = useRef(null)
    return (
        <div className='trarif-cards'
            style={{ marginBottom: !isMore ? '120px' : null }}>
            <div className='trarif-cards__content'>
                <div className='trarif-cards__card'>
                    <div className={`trarif-cards__selected`}>
                        <div className='trarif-cards__period'>

                            <div className='trarif-cards__period-selectors'>
                                {TARIFF_TYPES.map((item, i) => (
                                    <button className={`trarif-cards__period-selector ${selected === item.type ? 'trarif-cards__period-selector_selected' : ''}`} type='button' onClick={() => {
                                        if (selected === item.type) return
                                        setSelected(item.type)
                                    }}>
                                        <p className='trarif-cards__period-selector-text'>{item.title}</p>

                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className='trarif-cards__card-content'>
                            <div className='trarif-cards__card-main-info'>
                                <div className='trarif-cards__card-main-info-heading'>
                                    <svg className='trarif-cards__period-icon' width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.25 9V4.5" stroke="#AF90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M24.75 9V4.5" stroke="#AF90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M31.5 11.25V23.636C31.5 24.8295 31.0259 25.9741 30.182 26.818L26.818 30.182C25.9741 31.0259 24.8295 31.5 23.636 31.5H9C7.80653 31.5 6.66193 31.0259 5.81802 30.182C4.97411 29.3381 4.5 28.1935 4.5 27V11.25C4.5 10.0565 4.97411 8.91193 5.81802 8.06802C6.66193 7.22411 7.80653 6.75 9 6.75H27C28.1935 6.75 29.3381 7.22411 30.182 8.06802C31.0259 8.91193 31.5 10.0565 31.5 11.25Z" stroke="#AF90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M31.5 23.25H26.25C25.4544 23.25 24.6913 23.5661 24.1287 24.1287C23.5661 24.6913 23.25 25.4544 23.25 26.25V31.5" stroke="#AF90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M18 21V16.5" stroke="#AF90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M20.25 18.75H15.75" stroke="#AF90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <p
                                        className='trarif-cards__card-main-info-title'
                                        dangerouslySetInnerHTML={{ __html: TARIF.title }}
                                    ></p>
                                </div>
                                <p className='trarif-cards__card-main-info-description'>{TARIF.description}</p>
                            </div>
                            <div className='trarif-cards__card-price-info'>
                                <div className='trarif-cards__card-price'>
                                    <p className='trarif-cards__card-price-value'>{Number(TARIF.price).toLocaleString()}</p>
                                    <p className='trarif-cards__card-price-currency'>₽</p>
                                </div>
                                <button className='trarif-cards__card-price-btn' type='button' onClick={onStartPopupOpen}>
                                    Оплатить
                                </button>
                            </div>
                        </div>
                        <svg className='trarif-cards__card-sq-1' width="537" height="311" viewBox="0 0 537 311" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.7" d="M268.5 0L537 155.5L268.5 311L0 155.5L268.5 0Z" fill="#4F1886" fill-opacity="0.66" />
                        </svg>
                        <svg className='trarif-cards__card-sq-2' width="1297" height="751" viewBox="0 0 1297 751" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.7" d="M648.5 0L1297 375.5L648.5 751L0 375.5L648.5 0Z" fill="#4F1886" fill-opacity="0.46" />
                        </svg>
                        <svg className='trarif-cards__card-sq-3' width="816" height="473" viewBox="0 0 816 473" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.7" d="M408 0L816 236.5L408 473L0 236.5L408 0Z" fill="#8251EB" fill-opacity="0.34" />
                        </svg>
                        <svg className='trarif-cards__card-sq-4' width="537" height="311" viewBox="0 0 537 311" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.7" d="M268.5 0L537 155.5L268.5 311L0 155.5L268.5 0Z" fill="#9E51EB" fill-opacity="0.34" />
                        </svg>

                    </div>
                    {!isMore ?
                        <button className='trarif-cards__card-read-more' type='button' onClick={() => {
                            setIsMore(true)
                        }}>
                            <svg className='trarif-cards__card-read-more-icon' width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 22.2012C9.50326 22.2012 8.09245 21.9147 6.76758 21.3418C5.44987 20.7689 4.28613 19.9775 3.27637 18.9678C2.2666 17.958 1.47526 16.7943 0.902344 15.4766C0.329427 14.1517 0.0429688 12.7409 0.0429688 11.2441C0.0429688 9.7474 0.329427 8.34017 0.902344 7.02246C1.47526 5.69759 2.26302 4.53027 3.26562 3.52051C4.27539 2.51074 5.43913 1.7194 6.75684 1.14648C8.08171 0.573568 9.49251 0.287109 10.9893 0.287109C12.486 0.287109 13.8968 0.573568 15.2217 1.14648C16.5465 1.7194 17.7139 2.51074 18.7236 3.52051C19.7334 4.53027 20.5247 5.69759 21.0977 7.02246C21.6706 8.34017 21.957 9.7474 21.957 11.2441C21.957 12.7409 21.6706 14.1517 21.0977 15.4766C20.5247 16.7943 19.7334 17.958 18.7236 18.9678C17.7139 19.9775 16.5465 20.7689 15.2217 21.3418C13.904 21.9147 12.4967 22.2012 11 22.2012ZM11 20.375C12.2676 20.375 13.4528 20.1387 14.5557 19.666C15.6585 19.1934 16.6289 18.5417 17.4668 17.7109C18.3047 16.873 18.9564 15.9027 19.4219 14.7998C19.8945 13.6969 20.1309 12.5117 20.1309 11.2441C20.1309 9.97656 19.8945 8.79134 19.4219 7.68848C18.9492 6.58561 18.2939 5.61523 17.4561 4.77734C16.6253 3.93945 15.6549 3.28776 14.5449 2.82227C13.4421 2.34961 12.2568 2.11328 10.9893 2.11328C9.72168 2.11328 8.53646 2.34961 7.43359 2.82227C6.33073 3.28776 5.36393 3.93945 4.5332 4.77734C3.70247 5.61523 3.05078 6.58561 2.57812 7.68848C2.11263 8.79134 1.87988 9.97656 1.87988 11.2441C1.87988 12.5117 2.11263 13.6969 2.57812 14.7998C3.05078 15.9027 3.70247 16.873 4.5332 17.7109C5.37109 18.5417 6.34147 19.1934 7.44434 19.666C8.5472 20.1387 9.73242 20.375 11 20.375ZM9.12012 17.249C8.89811 17.249 8.71191 17.1774 8.56152 17.0342C8.41113 16.891 8.33594 16.7119 8.33594 16.4971C8.33594 16.2822 8.41113 16.1032 8.56152 15.96C8.71191 15.8167 8.89811 15.7451 9.12012 15.7451H10.4521V10.8145H9.30273C9.08073 10.8145 8.89453 10.7428 8.74414 10.5996C8.59375 10.4564 8.51855 10.2773 8.51855 10.0625C8.51855 9.84766 8.59375 9.66862 8.74414 9.52539C8.89453 9.38216 9.08073 9.31055 9.30273 9.31055H11.3223C11.5944 9.31055 11.8021 9.40007 11.9453 9.5791C12.0885 9.75098 12.1602 9.98372 12.1602 10.2773V15.7451H13.4922C13.7142 15.7451 13.9004 15.8167 14.0508 15.96C14.2012 16.1032 14.2764 16.2822 14.2764 16.4971C14.2764 16.7119 14.2012 16.891 14.0508 17.0342C13.9004 17.1774 13.7142 17.249 13.4922 17.249H9.12012ZM10.9033 7.5166C10.5166 7.5166 10.1872 7.38053 9.91504 7.1084C9.6429 6.83626 9.50684 6.50684 9.50684 6.12012C9.50684 5.72624 9.6429 5.39323 9.91504 5.12109C10.1872 4.84896 10.5166 4.71289 10.9033 4.71289C11.2972 4.71289 11.6266 4.84896 11.8916 5.12109C12.1637 5.39323 12.2998 5.72624 12.2998 6.12012C12.2998 6.50684 12.1637 6.83626 11.8916 7.1084C11.6266 7.38053 11.2972 7.5166 10.9033 7.5166Z" fill="white" />
                            </svg>
                            <p className='trarif-cards__card-read-more-text'>Что вы получите?</p>
                            <svg className='trarif-cards__card-read-more-arrow' width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.85858 6.85858C6.93668 6.93668 7.06332 6.93668 7.14142 6.85858L13 1" stroke="#FFC635" stroke-width="2" stroke-linecap="round" />
                            </svg>

                        </button>
                        : null}
                    <motion.div
                        className="trarif-cards__card-more"
                        ref={dropContentRef}
                        initial={{
                            height: "0px",
                            // marginBottom: "0px",
                            opacity: 0,
                            visibility: "hidden",
                        }}
                        animate={{
                            height: isMore ? dropContentRef.current.scrollHeight + "px" : "0px",
                            // marginBottom: isOpen ? "34px" : "0px",
                            opacity: isMore ? 1 : 0,
                            visibility: isMore ? "visible" : "hidden",
                        }}
                        transition={{ duration: 0.3, type: "tween" }}
                    >
                        <div className='trarif-cards__card-more-lists'>
                            <div className='trarif-cards__card-more-list-column'>
                                <div className='trarif-cards__card-more-list-box'>
                                    <div className='trarif-cards__card-more-list-heading'>
                                        <svg className='trarif-cards__card-more-list-heading-icon' width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M30.7358 9.52632C32.538 9.52632 33.999 8.06535 33.999 6.26316C33.999 4.46097 32.538 3 30.7358 3C28.9336 3 27.4727 4.46097 27.4727 6.26316C27.4727 8.06535 28.9336 9.52632 30.7358 9.52632Z" stroke="#FFB72A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M32 13.6667V25.9444C32 28.0809 31.122 30.1299 29.5592 31.6406C27.9964 33.1513 25.8768 34 23.6667 34H10.3333C8.1232 34 6.00358 33.1513 4.44078 31.6406C2.87797 30.1299 2 28.0809 2 25.9444V13.0556C2 10.9191 2.87797 8.87013 4.44078 7.35942C6.00358 5.84871 8.1232 5 10.3333 5H23" stroke="#FFB72A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M24.2072 14.4211L19.3125 19.3159" stroke="#FFB72A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M19.3172 19.3158L15.2383 15.2368" stroke="#FFB72A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M15.2391 15.2368L11.1602 19.3158" stroke="#FFB72A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.1602 24.2104H24.2128" stroke="#FFB72A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <p className='trarif-cards__card-more-list-heading-title'>Преимущества</p>
                                    </div>
                                    <div className='trarif-cards__card-more-list'>
                                        {ADVANTAGES.map((item, i) => (
                                            <div className='trarif-cards__card-more-list-item'>
                                                <svg className='trarif-cards__card-more-list-item-tick' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.6" d="M5 9.73077L8.5 13.5L15 6.5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <div className='trarif-cards__card-more-list-item-texts'>
                                                    {item.title ? <p className='trarif-cards__card-more-list-item-title'>{item.title}</p> : null}
                                                    {item.texts.map((item2, i2) => (
                                                        <p className='trarif-cards__card-more-list-item-text'>{item2}</p>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                                <img className='trarif-cards__card-more-image' src={advantages} alt='' />
                            </div>
                            <div className='trarif-cards__card-more-list-column'>
                                <div className='trarif-cards__card-more-list-box'>
                                    <div className='trarif-cards__card-more-list-heading'>
                                        <svg className='trarif-cards__card-more-list-heading-icon' width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.6875 12.9476V9.57934C3.6875 7.79269 4.39724 6.07922 5.66059 4.81587C6.92395 3.55252 8.63742 2.84277 10.4241 2.84277H27.2655C29.0521 2.84277 30.7656 3.55252 32.029 4.81587C33.2923 6.07922 34.0021 7.79269 34.0021 9.57934V26.4208C34.0021 28.2074 33.2923 29.9209 32.029 31.1842C30.7656 32.4476 29.0521 33.1573 27.2655 33.1573H23.8972" stroke="#18FFBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.05469 23.0525C7.05469 23.9458 7.40956 24.8026 8.04123 25.4342C8.67291 26.0659 9.52965 26.4208 10.423 26.4208C11.3163 26.4208 12.173 26.0659 12.8047 25.4342C13.4364 24.8026 13.7913 23.9458 13.7913 23.0525" stroke="#18FFBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M14.633 18H6.21231C3.88699 18 2.00195 19.885 2.00195 22.2104V28.9469C2.00195 31.2722 3.88699 33.1573 6.21231 33.1573H14.633C16.9583 33.1573 18.8434 31.2722 18.8434 28.9469V22.2104C18.8434 19.885 16.9583 18 14.633 18Z" stroke="#18FFBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M23.8965 9.57935V16.3159" stroke="#18FFBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M27.2639 12.9475H20.5273" stroke="#18FFBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <p className='trarif-cards__card-more-list-heading-title'>Управление товарами</p>
                                    </div>
                                    <div className='trarif-cards__card-more-list'>
                                        {PRODUCT_MANAGE.map((item, i) => (
                                            <div className='trarif-cards__card-more-list-item'>
                                                <svg className='trarif-cards__card-more-list-item-tick' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.6" d="M5 9.73077L8.5 13.5L15 6.5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <div className='trarif-cards__card-more-list-item-texts'>
                                                    {item.title ? <p className='trarif-cards__card-more-list-item-title'>{item.title}</p> : null}
                                                    {item.texts.map((item2, i2) => (
                                                        <p className='trarif-cards__card-more-list-item-text'>{item2}</p>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                                <div className='trarif-cards__card-more-list-box'>
                                    <div className='trarif-cards__card-more-list-heading'>
                                        <svg className='trarif-cards__card-more-list-heading-icon' width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M25.112 25.1112C26.5847 25.1112 27.7786 23.9173 27.7786 22.4445C27.7786 20.9717 26.5847 19.7778 25.112 19.7778C23.6392 19.7778 22.4453 20.9717 22.4453 22.4445C22.4453 23.9173 23.6392 25.1112 25.112 25.1112Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22.4453 31.3335H28.6675" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M31.3327 33.9998C32.8054 33.9998 33.9993 32.8059 33.9993 31.3332C33.9993 29.8604 32.8054 28.6665 31.3327 28.6665C29.8599 28.6665 28.666 29.8604 28.666 31.3332C28.666 32.8059 29.8599 33.9998 31.3327 33.9998Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M33.9996 22.4443H27.7773" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M2 12.6667H34" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M16.2218 7.32446L16.2129 7.33335L16.2218 7.34224L16.2307 7.33335L16.2218 7.32446Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.7765 7.32446L11.7676 7.33335L11.7765 7.34224L11.7854 7.33335L11.7765 7.32446Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.33311 7.32446L7.32422 7.33335L7.33311 7.34224L7.342 7.33335L7.33311 7.32446Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M16.2218 7.32446L16.2129 7.33335L16.2218 7.34224L16.2307 7.33335L16.2218 7.32446Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.7765 7.32446L11.7676 7.33335L11.7765 7.34224L11.7854 7.33335L11.7765 7.32446Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.33311 7.32446L7.32422 7.33335L7.33311 7.34224L7.342 7.33335L7.33311 7.32446Z" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M16.2222 34H7.33333C5.91885 34 4.56229 33.4381 3.5621 32.4379C2.5619 31.4377 2 30.0812 2 28.6667V7.33333C2 5.91885 2.5619 4.56229 3.5621 3.5621C4.56229 2.5619 5.91885 2 7.33333 2H28.6667C30.0812 2 31.4377 2.5619 32.4379 3.5621C33.4381 4.56229 34 5.91885 34 7.33333V16.2222" stroke="#74DEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                        <p className='trarif-cards__card-more-list-heading-title'>Управление сайтом</p>
                                    </div>
                                    <div className='trarif-cards__card-more-list'>
                                        {SITE_MANAGE.map((item, i) => (
                                            <div className='trarif-cards__card-more-list-item'>
                                                <svg className='trarif-cards__card-more-list-item-tick' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.6" d="M5 9.73077L8.5 13.5L15 6.5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <div className='trarif-cards__card-more-list-item-texts'>
                                                    {item.title ? <p className='trarif-cards__card-more-list-item-title'>{item.title}</p> : null}
                                                    {item.texts.map((item2, i2) => (
                                                        <p className='trarif-cards__card-more-list-item-text'>{item2}</p>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>

                    </motion.div>
                    {isMore ?
                        <button className='trarif-cards__card-read-more' type='button' onClick={() => {
                            setIsMore(false)
                        }}>
                            <svg className='trarif-cards__card-read-more-arrow trarif-cards__card-read-more-arrow_hide' width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 7L6.85858 1.14142C6.93668 1.06332 7.06332 1.06332 7.14142 1.14142L13 7" stroke="#FFC635" stroke-width="2" stroke-linecap="round" />
                            </svg>
                            <p className='trarif-cards__card-read-more-text'>Скрыть</p>
                        </button>
                        : null}
                </div>
            </div>
        </div>
    );
}

export default TrarifCards